<script>
/*global FaceView, */
/*eslint no-undef: "error"*/
import {
  defineComponent,
  watch,
  ref,
  nextTick,
  onMounted,
  computed,
} from "vue";
import { Layout } from "@/components";
import { GDialog } from "gitart-vue-dialog";
import { scriptsLoader } from "@/utils/scripts-loader";
import Step2 from "@/assets/svg/frame2.svg";
import Bub from "@/assets/svg/bub.svg";
// import Step41 from '@/assets/svg/testframe.svg'
import Step41 from "@/assets/svg/frame4-1.svg";
import Step42 from "@/assets/svg/frame4-2.svg";
import Step43 from "@/assets/svg/frame4-3.svg";
import Step31 from "@/assets/svg/frame3-1.svg";
import Step32 from "@/assets/svg/frame3-2.svg";
import Step33 from "@/assets/svg/frame3-3.svg";
import { Howl, Howler } from "howler";
import { shadowBody } from "@/utils/build";
import { date } from "quasar";

export default defineComponent({
  name: "App",
  components: {
    Layout,
    GDialog,
    Bub,
    Step2,
    Step41,
    Step42,
    Step43,
    Step31,
    Step32,
    Step33,
  },
  props: {
    user: {
      type: [String],
      default: () => null,
    },
    mode: {
      type: [String],
      default: () => null,
    },
    hide: {
      type: [String, Boolean],
      default: () => 'true',
    },
    skip: {
      type: [String, Boolean],
      default: () => 'true',
    },
  },
  emits: ["result", "closeMeasurement", "ok", "openTryOn"],
  setup(props, { emit }) {
    let step = ref(0);
    const camera = ref(null);
    const video_canvas = ref(null);
    const result = ref(null);
    const guide = ref(null);
    const videoRef = ref(null);
    let loading = ref(false);
    const isScriptsLoaded = ref(false);
    let pd = ref(0);
    let faceWidth = ref(0);
    let noseBridgeWidth = ref(0);
    let validFace = ref(false);
    let holdCard = ref(false);
    let getPd = ref(false);
    let finish = ref(false);
    let today = ref(null);
    let measuring = ref(false);
    let tick = ref(0);
    let firstMeasuring = ref(false);
    let firstValidFace = ref(false);
    let waiting = ref(true);
    let hide = ref(false)
    let mode = ref(null)
    let policyDialog = ref(false);
    let ended = ref(false);
    let readyForSuggestion = ref(false);
    let suggestedProducts = ref([]);
    let sortedGlasses = ref([]);
    let filteredGlasses = ref([]); // Filtered glasses from sortedGlasses based on slider values
    let faceImage = ref(null);
    let loadingMore = ref(false);
    const gender = ref('male');
    const slider1 = ref(null);
    const slider2 = ref(null);
    const slider3 = ref(null);
    const productScores = ref({});
    const sound = new Howl({
      src: [
        "https://production-glasson.s3.ap-northeast-1.amazonaws.com/hello-o/camera-shutter.mp3",
      ],
    });
    // const beep = new Howl({ src: ['https://production-glasson.s3.ap-northeast-1.amazonaws.com/hello-o/beep.mp3']});
    const beep = new Howl({
      src: [
        "https://production-glasson.s3.ap-northeast-1.amazonaws.com/hello-o/beep.mp3",
      ],
      volume: 0.2,
    });
    const sound1 = new Howl({
      src: [
        "https://production-glasson.s3.ap-northeast-1.amazonaws.com/assets/pd-measurement-voice-instruction/frame+3+-+landscape+1.mp3",
      ],
    });
    // const sound2 = new Howl({ src: ['https://production-glasson.s3.ap-northeast-1.amazonaws.com/assets/pd-measurement-voice-instruction/frame+3+-+landscape+2.mp3']})
    const sound41 = new Howl({
      src: [
        "https://production-glasson.s3.ap-northeast-1.amazonaws.com/assets/pd-measurement-voice-instruction/frame+4-1.mp3",
      ],
    });
    const sound42 = new Howl({
      src: [
        "https://production-glasson.s3.ap-northeast-1.amazonaws.com/assets/pd-measurement-voice-instruction/frame+4-2.mp3",
      ],
    });
    const sound43 = new Howl({
      src: [
        "https://production-glasson.s3.ap-northeast-1.amazonaws.com/assets/pd-measurement-voice-instruction/frame+4-3.mp3",
      ],
    });
    const sound44 = new Howl({
      src: [
        "https://production-glasson.s3.ap-northeast-1.amazonaws.com/assets/pd-measurement-voice-instruction/frame+4-4.mp3",
      ],
    });

    // var x = window.matchMedia("(max-width: 700px)")
    // x.addEventListener("change", function() {
    //   if (x.matches) {
    //     isMobile.value = true
    //   } else {
    //     isMobile.value = false
    //   }
    // });
    // const isMobile = ref(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    //   navigator.userAgent
    // ))
    const isMobile = computed(() =>
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) || mode.value === 'mobile'
    );
    function nextStep1() {
      step.value = 2;
      stopSound();
      // sound1.play();
    }
    function nextStep2() {
      step.value = 3;
      stopSound();
      setTimeout(setEnded, 19500);
    }
    function nextStep3() {
      // if (isMobile.value) {
      //   result.value.style.display = "none";
      //   // screen.orientation.lock("portrait-primary")
      // }
      step.value = 4;
      // nextTick(() => startCamera());
      sound41.on("end", function () {
        setTimeout(setWaiting, 1500);
      });
      sound42.on("end", function () {
        setTimeout(setWaiting, 1500);
      });
      sound43.on("end", function () {
        setTimeout(setWaiting, 1500);
      });
    }
    function setWaiting() {
      waiting.value = false;
    }

    function replay() {
      ended.value = false;
      videoRef.value.currentTime = 0;
      videoRef.value.play();
      setTimeout(setEnded, 19500);
    }
    function setEnded() {
      videoRef.value?.pause();
      ended.value = true;
    }

    function stopSound() {
      sound1.stop();
      // sound2.stop()
      sound41.stop();
      sound42.stop();
      sound43.stop();
      sound44.stop();
      if (videoRef.value) {
        videoRef.value.pause();
        videoRef.value.currentTime = 0;
      }
    }

    function setBestDPIForCanvas(canvas) {
      // console.log(window.devicePixelRatio)
      // const newRatio = window.devicePixelRatio > 2 ? 2 : window.devicePixelRatio
      const w = canvas.width;
      const h = canvas.height;
      canvas.width = w * window.devicePixelRatio;
      canvas.height = h * window.devicePixelRatio;
      // canvas.width = w * newRatio;
      // canvas.height = h * newRatio;
      canvas.style.width = w + "px";
      canvas.style.height = h + "px";
    }

    function resetDefault() {
      pd.value = 0;
      faceWidth.value = 0;
      noseBridgeWidth.value = 0;
      today.value = null;
      tick.value = 0;
      firstMeasuring.value = false;
      measuring.value = false;
      finish.value = false;
      firstValidFace.value = false;
      readyForSuggestion.value = false;
    }

    function clickRetake() {
      resetDefault();
      // if (isMobile.value) {
      //   guide.value.style.display = "block";
      //   result.value.style.display = "none";
      // }
      startCamera();
    }

    function handleOk() {
      emit('ok', {
        pd: pd.value,
        faceWidth: faceWidth.value,
        noseBridgeWidth: noseBridgeWidth.value,
      })
      onClose()
    }

    async function startCamera() {
      // if (!video_canvas.value || !camera.value) return;
      // loading.value = true;
      console.log("mode:", props.mode);
      if (isMobile.value) {
        // video_canvas.value.width = window.innerWidth;
        // video_canvas.value.height = window.innerHeight;
        video_canvas.value.width = camera.value.clientWidth;
        video_canvas.value.height = camera.value.clientHeight;
      } else {
        video_canvas.value.width = camera.value.clientWidth;
        video_canvas.value.height = camera.value.clientHeight;
        // video_canvas.value.height = video_canvas.value.width * 1.2;
        // if (video_canvas.value.width > 600) video_canvas.value.height = 600;
      }
      // Set best DPI for canvas
      setBestDPIForCanvas(video_canvas.value);
      await new Promise((resolve) => setTimeout(resolve), 100);
      let videoCanvas = video_canvas.value;
      let faceView = new FaceView("video_canvas", camera.value.getRootNode());
      // let catureValidatorView = new CatureValidatorView(videoCanvas);
      let catureValidatorView = undefined;
      faceView
        .start((faceInfo) => {
          // face event
          if (!faceInfo || !catureValidatorView) {
            resetDefault();
          } else if (hide.value === true) {
            faceView.stop();
          } else {
            if (catureValidatorView.isValidFace(faceInfo)) {
              tick.value += 1;
              firstValidFace.value = true;
              validFace.value = true;
              if (sound42.seek() === 0) {
                if (!waiting.value) {
                  stopSound();
                  // sound42.play();
                  waiting.value = true;
                }
              }
            } else {
              tick.value = 0;
              validFace.value = false;
              if (sound41.seek() === 0) {
                if (!waiting.value) {
                  stopSound();
                  // sound41.play();
                  waiting.value = true;
                }
              }
            }
            // if (faceInfo.haveCard) {
            //   tick.value += 1;
            //   holdCard.value = true;
            //   if (tick.value > 20) {
            //     measuring.value = true;
            //     firstMeasuring.value = true;
            //     if (sound43.seek() === 0) {
            //       if (!waiting.value) {
            //         stopSound();
            //         // sound43.play();
            //         waiting.value = true;
            //       }
            //     }
            //   }
            // } else {
            //   if (tick.value === 0) {
            //     // do nothing
            //   } else {
            //     measuring.value = false;
            //     tick.value = 0;
            //   }
            //   holdCard.value = false;
            // }
            if (catureValidatorView.isValidFace(faceInfo) && tick.value > 40) {
              stopSound();
              // sound.play();

              requestAnimationFrame(function () {
                faceView.stop();
              });

              readyForSuggestion.value = true;
              doSuggestion();
            }
            if (catureValidatorView.validate(faceInfo, false)) {
              // Do nothing
            } else {
              catureValidatorView.visual(faceInfo);
            }
          }
        })
        .then(
          function () {
            catureValidatorView = new CatureValidatorView(
              videoCanvas,
              camera.value.getRootNode()
            );
            catureValidatorView.drawCardGuide = () => {
              // Invalidated
            };
            catureValidatorView.drawCardBox = () => {
              // Invalidated
            };
            // sound41.play();
          },
          function (err) { }
        );
      //
    }

    function doSuggestion() {
      if (!readyForSuggestion.value) {
        return;
      }
      getPd.value = true;
      slider1.value = null;
      slider2.value = null;
      slider3.value = null;

      const formData = new FormData();
      formData.append("character", gender.value);
      formData.append("face_image", video_canvas.value.toDataURL("image/jpeg"));
      fetch(`https://glasses-suggestion.glasson.io/api/suggestion_api`, {
        method: "POST",
        body: formData,
      }).then(async (res) => {
        stopSound();
        // sound44.play();
        const data = await res.json();
        faceImage.value = data.result.face_image;

        // Get matching percentage for the face
        const faceMatchingPercentage = data.result.sorted_glasses.reduce((acc, productId, index) => {
          acc[productId] = data.result.scores[index];
          return acc;
        }, {});
        // console.log(faceMatchingPercentage);

        // Get product scores
        const response = await fetch('https://glasson.sk-global.biz/api/v2/product-scores?gender=' + gender.value);
        const list = await response.json();
        // Transform the data into the desired format: { [id]: { sku, scores } }
        productScores.value = list.reduce((acc, item) => {
          acc[item.id] = {
            sku: item.sku,
            scores: item.scores.map((score) => +score),
            faceMatching: faceMatchingPercentage[item.id],
          };
          return acc;
        }, {});
        // console.log(productScores.value);

        // Filter the delivered products only
        const deliveredIdList = Object.keys(productScores.value);
        sortedGlasses.value = data.result.sorted_glasses.filter((productId) => deliveredIdList.includes(productId));
        console.log(sortedGlasses.value);

        // Set initial slider values based on the best matching product
        const bestProductId = sortedGlasses.value[0];
        const bestProductScores = productScores.value[bestProductId].scores;
        getPd.value = false;
        slider1.value = bestProductScores[0];
        slider2.value = bestProductScores[1];
        slider3.value = bestProductScores[2];

        today.value = date.formatDate(new Date(), "DD/MM/YYYY");
        validFace.value = false;
        holdCard.value = false;
        measuring.value = false;
        firstMeasuring.value = false;
        finish.value = true;
      });
    }

    function roundNumberToOneDecimal(number) {
      const firstDecimal = Math.floor(number * 100) % 100;
      let roundedNumber;
      if (firstDecimal <= 25) {
        roundedNumber = Math.floor(number);
      } else if (firstDecimal <= 75) {
        roundedNumber = Math.floor(number) + 0.5;
      } else {
        roundedNumber = Math.ceil(number);
      }
      return roundedNumber;
    }

    function onClose() {
      const ins = document.querySelector("glasson-suggestion");
      ins.setAttribute("hide", true);
      resetDefault();
      step.value = 1;
      stopSound();
      emit("closeMeasurement");
    }

    watch(isScriptsLoaded, () => {
      if (isScriptsLoaded.value) {
        if (step.value === 0) {
          nextTick(() => (step.value = 1));
        }
      }
    });
    watch(
      () => props.hide,
      (newValue) => {
        hide.value = newValue === 'true'
        if (newValue === 'false') {
          nextTick(() => startCamera());
        }
        if (props.skip === 'true') {
          nextStep3()
        }
      },
      {
        immediate: true,
      },
    )
    watch(
      () => props.mode,
      (newValue) => {
        mode.value = newValue
      },
      {
        immediate: true,
      },
    )
    // watch(step, () => {
    //   if (step.value === 1) {
    //     stopSound()
    //     sound1.play()
    //   }
    // });

    const scripts = [
      // "https://glasson.sk-global.biz/pd-measurement/face_view.min.js",
      "https://glasson.sk-global.biz/binocle-pd-measurement/face_view_binocle.min.js",
      "https://cdn.jsdelivr.net/npm/@tensorflow-models/blazeface",
    ];
    scriptsLoader
      .reset()
      .addScript(scripts)
      .afterLoad()
      .onComplete(() => {
        // console.info("ALL SCRIPTS LOADED");
        isScriptsLoaded.value = true;
        // nextTick(() => startCamera());
      })
      .load();

    const isEnterprise = computed(() => window.location.hostname.includes('aldermiller.com'));

    function openTryOn(mode, groupId) {
      emit('openTryOn', { mode, groupId });
    }

    async function onLoadMoreResults(info) {
      // console.log(info);
      if (info.verticalPercentage < 0.9 || loadingMore.value) {
        return;
      }

      const startIndex = suggestedProducts.value.length;
      if (startIndex >= filteredGlasses.value.length) {
        return;
      }

      loadingMore.value = true;
      const pageN = filteredGlasses.value.slice(startIndex, startIndex + 5);
      const formData = new FormData();
      formData.append("face_path", faceImage.value);
      formData.append("glasses", pageN.join(","));
      fetch(`https://glasses-suggestion.glasson.io/api/tryon_api`, {
        method: "POST",
        body: formData,
      }).then(async (res) => {
        const data = await res.json();

        const moreResults = await Promise.all(
          pageN.map(async (productId) => {
            const res = await fetch(`https://glasson.sk-global.biz/api/v2/Products/findById?id=${productId}&storeId=40`);
            return await res.json();
          })
        );
        moreResults.forEach((item, index) => {
          item.tryOnImage = data.result.try_on_images[index];
        });
        suggestedProducts.value.push(...moreResults);
        // console.log(suggestedProducts.value);

        loadingMore.value = false;
      });
    }

    // Function to filter sortedGlasses based on slider values
    function filterGlasses() {
      if (getPd.value) {
        return;
      }
      filteredGlasses.value = sortedGlasses.value.filter((productId) => {
        const scores = productScores.value[productId].scores;
        return scores && scores[0] === slider1.value && scores[1] === slider2.value && scores[2] === slider3.value;
      });
      suggestedProducts.value = [];
      onLoadMoreResults({ verticalPercentage: 1 });

      // Emit the result
      const skuList = filteredGlasses.value.map((productId) => productScores.value[productId].sku);
      const scores = filteredGlasses.value.map((productId) => productScores.value[productId].faceMatching);
      emit("result", {
        skuList,
        scores,
        young: slider1.value,
        kind: slider2.value,
        simple: slider3.value,
        faceImage: faceImage.value,
      });
    }

    // Watchers for slider changes
    watch([slider1, slider2, slider3], filterGlasses);
    // Watchers for toggle changes
    watch([gender], doSuggestion);

    const genderOptions = [
      { label: '男性', value: 'male' },
      { label: '女性', value: 'female' }
    ];

    return {
      isScriptsLoaded,
      validFace,
      holdCard,
      finish,
      step,
      pd,
      camera,
      video_canvas,
      getPd,
      today,
      measuring,
      firstMeasuring,
      firstValidFace,
      result,
      guide,
      videoRef,
      policyDialog,
      isMobile,
      ended,
      faceWidth,
      noseBridgeWidth,
      startCamera,
      clickRetake,
      nextStep1,
      nextStep2,
      nextStep3,
      onClose,
      replay,
      handleOk,
      isEnterprise,
      productScores,
      suggestedProducts,
      openTryOn,
      loadingMore,
      onLoadMoreResults,
      gender,
      genderOptions,
      slider1,
      slider2,
      slider3,
    };
  },
});
</script>

<template>
  <Layout :hide="hide">
    <template #footer>
      <a v-if="!isEnterprise" href="https://glasson.sk-global.biz/" class="powered-btn">
        Powered by <b>GlassOn</b>
      </a>
    </template>

    <q-card v-if="step === 0" class="fit q-pa-md">
      <div class="div-close-btn">
        <q-btn
          size="sm"
          outline
          round
          icon="close"
          class="close-btn"
          @click="onClose"
          style="background-color: white !important"
        />
      </div>
      <q-card-section class="flex flex-center frame">
        <div>
          <div class="text-title-1 text-center">
            PUPIL DISTANCE (PD) MEASUREMENT
          </div>
          <!-- <div class="text-subtitle-1 text-center">
            This measurement is essential for the precise centering of lenses on your frame.
          </div> -->
          <div class="guide-area text-center q-mt-lg">
            <Step2 />
          </div>
          <div class="text-subtitle-1 text-center preline">
            Please turn up the volume on your device to follow our instruction.
            By tapping "Start", you agree with our
            <span class="clickable-text text-subtitle-1" @click="policyDialog = true">privacy policy</span>.
          </div>
          <div class="action-btn-1 text-center q-mt-lg">
            <q-btn
              no-caps
              size="md"
              text-color="white"
              class="background-primary radius-btn"
              @click="nextStep1"
              label="Start"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>

    <q-card v-if="step === 1" class="fit q-pa-md">
      <div class="div-close-btn">
        <q-btn
          size="sm"
          outline
          round
          icon="close"
          class="close-btn"
          @click="onClose"
          style="background-color: white !important"
        />
      </div>
      <q-card-section class="flex flex-center frame">
        <div>
          <div class="text-title-1 text-center">
            PUPIL DISTANCE (PD) MEASUREMENT
          </div>
          <!-- <div class="text-subtitle-1 text-center">
            This measurement is essential for the precise centering of lenses on your frame.
          </div> -->
          <div class="guide-area text-center q-mt-lg">
            <Step2 />
          </div>
          <div class="text-subtitle-1 text-center preline">
            Please turn up the volume on your device to follow our instruction.
            By tapping "Start", you agree with our
            <span class="clickable-text" @click="policyDialog = true">privacy policy</span>.
          </div>
          <div class="action-btn-1 text-center q-mt-lg">
            <q-btn
              no-caps
              size="md"
              text-color="white"
              class="background-primary radius-btn"
              @click="nextStep1"
              label="Start"
            />
          </div>
        </div>
      </q-card-section>
      <GDialog
        transition="custom-from-right-transition"
        v-model="policyDialog"
        local
        max-width="900"
      >
        <q-card class="policy-card">
          <div class="div-close-btn-policy">
            <q-btn
              size="sm"
              outline
              round
              icon="close"
              class="close-btn"
              @click="policyDialog = false"
              style="background-color: white !important"
            />
          </div>
          <q-card-section class="q-pb-none policy-body">
            <pre class="policy-text" style="white-space: break-spaces">
<b>PRIVACY POLICY</b>

This privacy policy for Spring Knowledge Global Joint Stock Company (doing business as SK-Global) (<b>“SK-Global,” “we,” “us,” or “our”</b>), describe how and why we might collect, store, use and/or share (<b>“process”</b>) your information when you use our services (<b>“Services”</b>), such as when you:
  -  Visit our (<a href="https://glasson.sk-global.biz/">https://glasson.sk-global.biz/</a>) (<b>“Sites”</b>), install or use our GlassOn mobile applications, SDK and software tools (<b>“Apps”</b>), or use our online platform, hosted on the Sites;
  -  Engage with us in other related ways, including any sales, marketing, or events.

Reading this privacy policy will help you understand your privacy rights and choices. If you do not agree with our policies and practices, please do not use our Services. If you still have any questions or concerns, please contact us at <a href="mailto:glasson@sk-global.biz">glasson@sk-global.biz</a>.

<b>What personal information do we process?</b>
When you visit, use or navigate our Services, we may process personal information depending on how you interact with the Services, the choices you make, and the products and features you use. The personal information we collect may include the following:
  -  Names
  -  Email Addresses
  -  Pupil Distance Measurement Data
  -  Mailing Addresses
Please note that we do not process sensitive information or store any of your photos after the Pupil Distance Measurement.

All personal information that you provide to us must be true, complete and accurate, and you must notify us of any changes to such personal information.

<b>Do we receive any information from third parties?</b>
We do not receive any information from third parties.

<b>How do we process your information?</b>
We process your information to provide, improve and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent. We process your information only when we have a valid legal reason to do so.

<b>In what situations and with which parties do we share personal information?</b>
We may share information in specific situations and with specific third parties.

In particular, we may need to share your personal information in the following situations:
  -  <b>Business Transfer</b>: We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.
  -  <b>When we use Google Maps Platform APIs</b>: We may share your information with certain Google Maps Platform APIs (e.g., Google Maps API, Places API). We obtain and store on your device (<b>“cache”</b>) your location. You may revoke your consent anytime by contacting us at the contact details provided at the end of this document.
  -  <b>Affiliates</b>: We may share your information with our affiliates, in which case we will require those affiliates to honor this privacy policy. Affiliates include our parent company and any subsidiaries, joint venture partners, or other companies that we control or that are under common control with us.
  -  <b>Business Partner</b>: We may share your information with our business partners to offer you certain products, services, or promotions.

<b>How do we keep your information safe?</b>
We have organizational and technical processes and procedures in place to protect your personal information. However, no electronic transmission over the internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or unauthorized third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information.

<b>How can you contact us about this privacy?</b>
If you have questions or comments about this privacy, you may email us at <a href="mailto:glasson@sk-global.biz">glasson@sk-global.biz</a> or by post to:

SPRING KNOWLEDGE GLOBAL JOINT STOCK COMPANY
Phone: (+84)909 189 329
Address: 74/13/4 Truong Quoc Dung St. Phu Nhuan Dist.
Ho Chi Minh City 700000
Vietnam
                </pre>
          </q-card-section>
        </q-card>
      </GDialog>
    </q-card>

    <q-card v-if="step === 2" class="fit q-pa-md">
      <div class="div-close-btn">
        <q-btn
          size="sm"
          outline
          round
          icon="close"
          class="close-btn"
          @click="onClose"
          style="background-color: white !important"
        />
      </div>
      <q-card-section class="flex flex-center frame">
        <div>
          <div class="text-title-2 text-center">Before getting started</div>
          <div class="text-subtitle-2 text-center q-mb-lg mobile-mb-none">
            You will need to
          </div>
          <div class="guide-area-2 q-gutter-md q-mb-lg">
            <Step31 class="guide" />
            <Step32 class="guide" />
            <Step33 class="guide" />
            <!-- <q-img src="@/assets/svg/frame3-1.png" class="guide" />
              <q-img src="@/assets/svg/frame3-2.png" class="guide" />
              <q-img src="@/assets/svg/frame3-3.png" class="guide" /> -->
          </div>
        </div>
      </q-card-section>
      <div class="action-btn-2 text-center">
        <q-btn
          no-caps
          size="lg"
          text-color="white"
          class="background-primary q-px-xl radius-btn"
          @click="nextStep2"
          label="Next"
        />
      </div>
    </q-card>

    <q-card v-if="step === 3" class="fit q-pa-md">
      <div class="div-close-btn">
        <q-btn
          size="sm"
          outline
          round
          icon="close"
          class="close-btn"
          @click="onClose"
          style="background-color: white !important"
        />
      </div>
      <q-card-section class="flex flex-center frame">
        <div>
          <div class="video-intro">
            <div
              @click="replay"
              v-if="ended"
              class="video-intro flex flex-center"
              style="
                position: absolute;
                background-color: rgba(255, 255, 255, 0.5);
                z-index: 3000;
              "
            >
              <q-btn
                round
                text-color="white"
                icon="replay"
                class="background-primary"
              />
            </div>
            <video
              ref="videoRef"
              id="videoRef"
              class="video-intro"
              playsinline=""
              autoplay=""
              poster=""
              preload="auto"
            >
              <source
                src="https://d3lgac2qoojxa5.cloudfront.net/assets/pd-measurement-voice-instruction/instruction.mp4"
              />
            </video>
            <!-- <q-video
              fetchpriority="high"
              class="video-intro"
              src="https://production-glasson.s3.ap-northeast-1.amazonaws.com/assets/3FAD3CDA-58E0-4BB9-AFA8-B9B0A7D750E7.MOV"
            /> -->
          </div>
          <div class="flex flex-center q-mt-lg">
            <Bub />
            <span class="hint-text text-center" style="max-width: 65vw;">
              Please allow the access to your camera to start the scan.
            </span>
          </div>
        </div>
      </q-card-section>
      <div class="action-btn text-center q-mt-sm">
        <q-btn
          no-caps
          size="lg"
          text-color="white"
          class="background-primary q-px-xl radius-btn"
          @click="nextStep3"
          label="Next"
        />
      </div>
    </q-card>

    <q-card v-show="step === 4" class="fit q-pa-md card-step-4">
      <!-- <div class="div-close-btn q-mb-sm">
        <q-btn
          size="sm"
          outline
          round
          icon="close"
          class="close-btn"
          @click="onClose"
          style="background-color: white !important"
        />
      </div> -->
      <div class="fit row" :class="{ 'q-gutter-lg': !isMobile }">
        <div v-if="!isMobile || (isMobile && !finish)" ref="guide" class="guide-area-3">
          <div class="q-gutter-md">
            <div class="text-title-3 text-center step-4-title">
              Steps To Get Suggestion
            </div>
            <q-card flat class="text-center guide-step-4">
              <div class="relative-position" :class="{ 'q-mx-auto': !isMobile, 'q-mx-xs': isMobile }" style="width: fit-content;">
                <q-icon
                  v-if="firstValidFace && !validFace"
                  size="xs"
                  name="cancel"
                  class="top-icon red"
                />
                <q-icon
                  v-if="validFace || finish"
                  size="xs"
                  name="check_circle"
                  class="top-icon"
                  :class="validFace || finish ? 'green' : 'hide'"
                />
                <Step41
                  :class="
                    validFace || finish
                      ? 'guide-card-green'
                      : firstValidFace && !validFace
                      ? 'guide-card-red'
                      : 'guide-card-grey'
                  "
                  class="padding-card-1"
                />
              </div>
              <div>Put your face in the dotted area</div>
            </q-card>
            <q-card flat class="text-center guide-step-4">
              <div class="relative-position" :class="{ 'q-mx-auto': !isMobile, 'q-mx-xs': isMobile }" style="width: fit-content;">
                <q-icon
                  v-if="firstMeasuring && !holdCard"
                  size="xs"
                  name="cancel"
                  class="top-icon red"
                />
                <q-icon
                  v-if="getPd || finish"
                  size="xs"
                  name="check_circle"
                  class="check_circle top-icon green"
                />
                <Step43
                  :class="
                    firstMeasuring && !holdCard
                      ? 'guide-card-red'
                      : getPd || finish
                      ? 'guide-card-green'
                      : 'guide-card-grey'
                  "
                  class="padding-card-3"
                />
              </div>
              <div>Hold it for a few seconds</div>
            </q-card>
            <!-- <q-card flat :class="validFace ? 'guide-card-green' : 'guide-card-black'" class="guide-card">
                <q-card-section class="card-pd">
                  <q-icon size="lg" name="check_circle" class="check_circle" />
                  <span>Put your face in the dotted area</span>
                </q-card-section>
              </q-card>
              <q-card flat :class="holdCard ? 'guide-card-green' : 'guide-card-black'" class="guide-card">
                <q-card-section class="card-pd">
                  <q-icon size="lg" name="check_circle" class="check_circle" />
                  <span>Stick the card to your forehead</span>
                </q-card-section>
              </q-card>
              <q-card flat :class="firstMeasuring && !holdCard ? 'guide-card-red' : holdCard && validFace ? 'guide-card-green' : 'guide-card-black'" class="guide-card">
                <q-card-section class="card-pd">
                  <q-icon v-if="firstMeasuring && !holdCard" size="lg" name="cancel" class="check_circle"  />
                  <q-icon v-else size="lg" name="check_circle" class="check_circle" />
                  <span>Hold it for a few seconds</span>
                </q-card-section>
              </q-card> -->
          </div>
        </div>
        <div class="col">
          <div
            ref="camera"
            style="width: 100%; height: 100%; position: relative"
          >
            <div v-if="getPd" class="scanner">
              <!-- <div class="scanner"> -->
              <em></em>
              <span></span>
            </div>
            <canvas
              id="video_canvas"
              ref="video_canvas"
              style="width: 100%; height: 100%"
            />
            <video id="video" playsinline style="display: none" />
          </div>
        </div>

        <div v-if="isMobile && finish" ref="result" class="result-card">
          <q-card class="guide-card-grey card-shadow">
            <q-card-section>
              <div class="text-center measurement-title text-title-3 q-mb-md text-bold">
                <!-- <div>PD Measurement</div> -->
                <div>Result</div>
              </div>
              <!-- <div class="q-mb-sm">Date: {{ today }}</div> -->
              <!-- <div>Your PD:</div>
              <div class="circle">
                <div class="circle-text-1">{{ pd }}</div>
                <div class="circle-text-2">mm</div>
              </div> -->
              <!-- <div
                class="text-subtitle-1 text-bold"
              >
                Pupil Distance
              </div> -->
              <q-scroll-area
                v-if="suggestedProducts.length >= 0"
                @scroll="onLoadMoreResults"
                style="height: 50vh;"
              >
                <div class="q-mb-md row items-center justify-center q-gutter-y-xs" v-for="product of suggestedProducts" :key="product.id">
                  <q-img
                    :src="'https://glasses-suggestion.glasson.io/' + product.tryOnImage"
                    fit="cover"
                    style="width: 100%; height: 150px;"
                  >
                    <div class="absolute-bottom-right" style="padding: 0; background-color: transparent;">
                      <q-chip dense color="white" text-color="black">{{ productScores[product.id].faceMatching }}%</q-chip>
                    </div>
                  </q-img>
                  <div class="full-width row items-center justify-between no-wrap">
                    <small>{{ product.sku }}</small>
                    <q-btn class="text-no-wrap" color="primary" outline dense @click="openTryOn('live', product.groupId)">Try-On</q-btn>
                  </div>
                </div>
                <template v-if="loadingMore">
                  <div class="row justify-center">
                    <q-spinner-dots color="primary" size="40px" />
                  </div>
                </template>
                <div v-if="!loadingMore && suggestedProducts.length === 0" class="text-center">
                  No results found
                </div>
              </q-scroll-area>
            </q-card-section>
          </q-card>
          <div v-if="finish" class="text-center q-mt-lg retake-btn">
            <q-btn
              no-caps
              size="lg"
              text-color="white"
              class="bg-grey q-px-xl radius-btn"
              @click="clickRetake"
              label="Retake"
            />
            <!-- <q-btn
              no-caps
              size="lg"
              text-color="white"
              class="background-primary q-px-lg q-ml-md radius-btn"
              @click="handleOk"
              label="OK"
            /> -->
          </div>
        </div>
        <div v-if="!isMobile" ref="result" class="result-card" style="max-height: 100%;">
          <div class="text-title-3 text-center q-mb-sm">Result</div>
          <q-scroll-area
            v-if="suggestedProducts.length >= 0"
            @scroll="onLoadMoreResults"
            class="q-mb-lg"
            style="height: calc(100% - 105px);"
          >
            <q-card class="result-card-grey q-ma-md" v-for="product of suggestedProducts" :key="product.id">
              <q-card-section class="row items-center justify-center q-gutter-y-xs">
                <q-img
                  :src="'https://glasses-suggestion.glasson.io/' + product.tryOnImage"
                  fit="cover"
                  style="width: 100%; height: 150px;"
                >
                  <div class="absolute-bottom-right" style="padding: 0; background-color: transparent;">
                    <q-chip dense color="white" text-color="black">{{ productScores[product.id].faceMatching }}%</q-chip>
                  </div>
                </q-img>
                <div class="full-width row items-center justify-between no-wrap">
                  <small>{{ product.sku }}</small>
                  <q-btn class="text-no-wrap" color="primary" outline dense @click="openTryOn('live', product.groupId)">Try-On</q-btn>
                </div>
                <!-- <div
                  class="measurement-title text-title-3 text-bold"
                >
                  Pupil Distance
                </div>
                <div class="flex" style="align-items: baseline;">
                  <div class="text-result-value q-mr-sm">{{ pd }}</div>
                  <div class="text-grey">mm</div>
                </div> -->
                <!-- <div class="result-area">
                  <div class="circle-text-1">{{ pd }}</div>
                  <div class="circle-text-2">mm</div>
                </div> -->
                <!-- <div v-show="finish" class="q-mb-sm">Date: {{ today }}</div> -->
              </q-card-section>
            </q-card>
            <template v-if="loadingMore">
              <div class="row justify-center">
                <q-spinner-dots color="primary" size="40px" />
              </div>
            </template>
            <div v-if="!loadingMore && suggestedProducts.length === 0" class="text-center">
              No results found
            </div>
          </q-scroll-area>
          <div v-if="finish" class="column q-gutter-lg retake-btn">
            <!-- <q-btn
              no-caps
              size="lg"
              text-color="white"
              class="background-primary radius-btn"
              @click="handleOk"
              label="OK"
            /> -->
            <q-btn
              no-caps
              size="lg"
              text-color="white"
              class="bg-grey radius-btn"
              @click="clickRetake"
              label="Retake"
            />
          </div>
        </div>

        <div class="absolute-bottom q-py-xl" style="max-width: 100%; width: 270px;">
          <div class="q-mb-md">
            <div class="row items-center">
              <div class="col-3">性別</div>
              <q-btn-toggle v-model="gender" class="my-custom-toggle" no-caps rounded unelevated toggle-color="primary"
                color="white" text-color="primary" :options="genderOptions" />
            </div>
          </div>

          <!-- Slider 1: 若々しい to 大人っぽい -->
          <div v-if="finish" class="q-mb-md">
            <div class="row items-center">
              <div class="col-3">若々しい</div>
              <q-slider v-model="slider1" :min="1" :max="4" markers color="primary" class="col" />
              <div class="col-4 q-pl-md">大人っぽい</div>
            </div>
          </div>

          <!-- Slider 2: 優しい to 凛々しい -->
          <div v-if="finish" class="q-mb-md">
            <div class="row items-center">
              <div class="col-3">優しい</div>
              <q-slider v-model="slider2" :min="1" :max="4" markers color="secondary" class="col" />
              <div class="col-4 q-pl-md">凛々しい</div>
            </div>
          </div>

          <!-- Slider 3: シンプル to ゴージャス -->
          <div v-if="finish" class="q-mb-md">
            <div class="row items-center">
              <div class="col-3">シンプル</div>
              <q-slider v-model="slider3" :min="1" :max="4" markers color="accent" class="col" />
              <div class="col-4 q-pl-md">ゴージャス</div>
            </div>
          </div>
        </div>
      </div>
    </q-card>
  </Layout>
</template>

<style lang="scss">
@import "assets/scss/app.scss";

@keyframes count {
  100% {
    opacity: 0;
    transform: scale(0.5);
  }

  0% {
    opacity: 1;
    transform: scale(1.5);
  }
}

.countdown {
  width: 20px;
  position: relative;
  bottom: 5%;
  left: 45%;
  z-index: 9999;
  color: #66cc66;
  font-size: 2.5rem;
}

.animation {
  animation: count 1.5s infinite;
}

.oval {
  position: absolute;
  width: 60%;
  height: 60%;
  top: 20%;
  left: 20%;
  // border-radius: 100px / 160px;
  // border: 1px black dashed;
}

.my-custom-toggle {
  border: 1px solid #027be3
}
</style>
